import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";


const ResultView = (props: any) => {
    const navigate = useNavigate();
    const { result, message } = props;

    const redirectListing = () => {
        navigate("/");
    };
    
    return(
        <div className="subscription-container">
            <div className="card-subscription">
                <div className="card-subscription-cont">
                    <span className={(result === 200) ? "pi pi-check-circle" : "pi pi-times-circle"}></span>
                    <div className="card-subscription-status">{message}</div>
                </div>
                <button className="btn btn-primary completion-btn-primary" onClick={redirectListing}>Back To Job Listings</button>            
            </div>
            
        </div>
    );
};

export default ResultView;